import React, { useState, useCallback , useRef, useEffect} from 'react';
import { Link } from 'react-router-dom';
import salesforceDevImage from '../../images/copado-course.png';
import salesforceAiImage from '../../images/salesforce-ai.png';
import AnimateIn from './AnimateIn';
import './UpcomingBatches.css';

const VISIBLE_COUNT = 3;
const TRANSITION_MS = 350;
const KONFHUB_SCRIPT_URL = 'https://widget.konfhub.com/widget.js';
// const KONFHUB_BUTTON_ID = 'btn_f73dfe6e992a';
const KONFHUB_BUTTON_IDS = {
  'salesforce-developer': 'btn_f9b8c7a58b83',
  'salesforce-ai-developer': 'btn_f9b8c7a58b83',
  'salesforce-devops-copado-agentia': 'btn_483b56d18976',
};



const UpcomingBatches = ({ title = 'Upcoming Batches', batches = [] }) => {
  const [slideIndex, setSlideIndex] = useState(0);
  const [skipTransition, setSkipTransition] = useState(false);

  // NOTE: Slider logic kept for future use but disabled for now.
  // const useSlider = batches.length > VISIBLE_COUNT;
  // const maxSlide = Math.max(0, batches.length - VISIBLE_COUNT);
  // const duplicatedBatches = useSlider ? [...batches, ...batches] : batches;
  // const totalCards = duplicatedBatches.length;
  const scriptContainerRef = useRef(null);

  // const getTransform = useCallback(
  //   (index) => {
  //     if (index === -1) {
  //       return `translateX(-${((totalCards - VISIBLE_COUNT) / totalCards) * 100}%)`;
  //     }
  //     return `translateX(-${(index * 100) / totalCards}%)`;
  //   },
  //   [totalCards]
  // );

  useEffect(() => {
    const container = scriptContainerRef.current;
    if (!container) return;
  
    const wrappers = [];
  
    Object.entries(KONFHUB_BUTTON_IDS).forEach(([courseSlug, buttonId]) => {
      const wrapper = document.createElement('div');
      wrapper.id = buttonId;
  
      const script = document.createElement('script');
      script.src = KONFHUB_SCRIPT_URL;
      script.async = true;
      script.setAttribute('button_id', buttonId);
  
      wrapper.appendChild(script);
      container.appendChild(wrapper);
  
      wrappers.push(wrapper);
    });
  
    return () => {
      wrappers.forEach((wrapper) => {
        if (wrapper.parentNode === container) {
          container.removeChild(wrapper);
        }
      });
    };
  }, []);
  
  
  
  const handleKonfhubClick = (courseKey, e) => {
    e.preventDefault();
  
    const container = scriptContainerRef.current;
    if (!container) return;
  
    const buttonId = KONFHUB_BUTTON_IDS[courseKey];
  
    console.log('Course:', courseKey);
    console.log('Button ID:', buttonId);
  
    if (!buttonId) {
      console.warn('No KonfHub button configured for:', courseKey);
      return;
    }
  
    const wrapper = container.querySelector(`#${CSS.escape(buttonId)}`);
  
    if (!wrapper) {
      console.warn('Wrapper not found for:', buttonId);
      return;
    }
  
    const button = wrapper.querySelector('button');
  
    if (button) {
      button.click();
      return;
    }
  
    // Retry after widget loads
    setTimeout(() => {
      const retryButton = wrapper.querySelector('button');
  
      if (retryButton) {
        retryButton.click();
      } else {
        console.warn(
          'KonfHub widget button still not available:',
          courseKey
        );
      }
    }, 1000);
  };

  

  // const handleTransitionEnd = useCallback(
  //   (e) => {
  //     if (e.target !== e.currentTarget || e.propertyName !== 'transform') return;
  //     if (slideIndex === -1) {
  //       setSkipTransition(true);
  //       setSlideIndex(maxSlide);
  //       requestAnimationFrame(() => {
  //         requestAnimationFrame(() => setSkipTransition(false));
  //       });
  //     } else if (slideIndex === maxSlide + 1) {
  //       setSkipTransition(true);
  //       setSlideIndex(0);
  //       requestAnimationFrame(() => {
  //         requestAnimationFrame(() => setSkipTransition(false));
  //       });
  //     }
  //   },
  //   [slideIndex, maxSlide]
  // );

  // const goPrev = () => setSlideIndex((i) => (i <= 0 ? -1 : i - 1));
  // const goNext = () => setSlideIndex((i) => (i >= maxSlide ? maxSlide + 1 : i + 1));

  // One step: click "Enroll now" → KonfHub popup opens directly. No overlay, no 2nd button. Homepage unchanged.
  // const openKonfhubPopup = (e) => {
  //   e.preventDefault();
  //   const trigger = document.getElementById(KONFHUB_BUTTON_ID);
  //   const scriptLoaded = document.querySelector(`script[src="${KONFHUB_SCRIPT_URL}"]`);

  //   const clickKonfhubButton = () => {
  //     const el = document.getElementById(KONFHUB_BUTTON_ID);
  //     if (!el) return;
  //     const btn = el.querySelector('button, a, [role="button"], [class*="btn"]') || el;
  //     btn.click();
  //   };

  //   if (scriptLoaded && trigger) {
  //     clickKonfhubButton();
  //     return;
  //   }

  //   if (!trigger) {
  //     const div = document.createElement('div');
  //     div.id = KONFHUB_BUTTON_ID;
  //     div.setAttribute('aria-hidden', 'true');
  //     div.style.cssText =
  //       'position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden;pointer-events:auto;';
  //     document.body.appendChild(div);
  //   }

  //   if (!scriptLoaded) {
  //     const script = document.createElement('script');
  //     script.src = KONFHUB_SCRIPT_URL;
  //     script.setAttribute('button_id', KONFHUB_BUTTON_ID);
  //     script.async = true;
  //     script.onload = () => {
  //       setTimeout(clickKonfhubButton, 500);
  //     };
  //     document.body.appendChild(script);
  //   } else {
  //     setTimeout(clickKonfhubButton, 200);
  //   }
  // };

  if (batches.length === 0) return null;

  // Highlight Salesforce batches on homepage
  const highlightedBatches = batches.filter(
    (batch) =>
      batch.courseSlug === 'salesforce-ai-developer' ||
      batch.courseSlug === 'salesforce-devops-copado-agentia'
  );
  const batchesToRender =
    highlightedBatches.length > 0 ? highlightedBatches.slice(0, 2) : batches.slice(0, 2);

  return (
    <section className="upcoming-batches" id="upcoming-batches">
      
      <div
  ref={scriptContainerRef}
  aria-hidden="true"
  style={{
    // position: "fixed",
    // left: "-9999px",
    // top: "0",
    width: "0px",
    height: "0px",
     overflow: "hidden",
    // opacity: 0,
    // pointerEvents: "auto",
     // keep it "clickable" if ever needed
  }}
/>

      <div className="upcoming-batches-container">
        <AnimateIn direction="up">
          <h2 className="upcoming-batches-title">{title}</h2>
        </AnimateIn>
        <div className="upcoming-batches-wrap">
          {/* Slider UI commented out for now, kept for future use */}
          {/*
          {useSlider && (
            <button
              type="button"
              className="upcoming-batches-nav upcoming-batches-prev"
              onClick={goPrev}
              aria-label="Previous batches"
            >
              ‹
            </button>
          )}
          <div className={`upcoming-batches-track ${useSlider ? 'upcoming-batches-track--slider' : ''}`}>
            <div
              className="upcoming-batches-grid"
              style={gridSliderStyle}
              onTransitionEnd={handleTransitionEnd}
            >
              {duplicatedBatches.map((batch, i) => (
          */}
          <div className="upcoming-batches-track">
            <div className="upcoming-batches-grid">
              {batchesToRender.map((batch, i) => (
                <article
                  key={i}
                  className="upcoming-batch-card"
                  // style={cardSliderStyle} // slider sizing kept for future use
                >
                  <div className="upcoming-batch-card-image-wrap">
                    <img
                      src={
                        batch.courseSlug === 'salesforce-developer' ||
                        batch.courseSlug === 'salesforce-devops-copado-agentia'
                          ? salesforceDevImage
                          : batch.courseSlug === 'salesforce-ai-developer'
                            ? salesforceAiImage
                            : batch.imageUrl
                      }
                      alt=""
                      className="upcoming-batch-card-image"
                      loading="lazy"
                    />
                  </div>
                  <div className="upcoming-batch-card-body">
                    <h3 className="upcoming-batch-card-title">{batch.courseName}</h3>
                    <div className="upcoming-batch-card-meta">
                      <span className="upcoming-batch-date">Start Date: {batch.date}</span>
                    </div>
                    <div className="upcoming-batch-card-meta">
                      <span className="upcoming-batch-time">Time: {batch.time}</span>
                    </div>
                    <div className="upcoming-batch-actions">
                      <button
                        type="button"
                        className="upcoming-batch-enroll-btn"
                        onClick={(e) => handleKonfhubClick(batch.courseSlug, e)}
                      >
                        Enroll now
                      </button>
                      <Link
                        to={`/course/${batch.courseSlug}?date=${encodeURIComponent(batch.date)}&time=${encodeURIComponent(batch.time)}`}
                        className="upcoming-batch-view-link"
                      >
                        View details
                      </Link>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
          {/* {useSlider && (
            <button
              type="button"
              className="upcoming-batches-nav upcoming-batches-next"
              onClick={goNext}
              aria-label="Next batches"
            >
              ›
            </button>
          )} */}
        </div>
      </div>
    </section>
  );
};

export default UpcomingBatches;